export type DesignVersion = 'legacy' | 'modern';

const STORAGE_KEY = 'fishDesignVersion';

export function getDesignVersionLocalStorage(): DesignVersion {
  return localStorage.getItem(STORAGE_KEY) === 'modern' ? 'modern' : 'legacy';
}

export function setDesignVersionLocalStorage(version: DesignVersion) {
  if (version === 'modern') {
    localStorage.setItem(STORAGE_KEY, 'modern');
    return;
  }

  localStorage.removeItem(STORAGE_KEY);
}
